import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  inject,
  ChangeDetectionStrategy,
  input,
  effect,
  viewChildren,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FormArray, FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { CvaBaseComponent } from 'shared';

@Component({
  selector: 'tngh-pin-input',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './pin-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pin-input.component.scss'],
})
export class PinInputComponent extends CvaBaseComponent implements OnInit, AfterViewInit {
  private readonly fb = inject(FormBuilder);

  readonly isCodeHidden = input(true);
  readonly numOfDigits = input(6);

  readonly inputElements = viewChildren<ElementRef>('inputs');

  constructor() {
    super();
    this.formControl = this.fb.array([]);

    effect(() => {
      const value = this.numOfDigits();
      if (value) {
        this.formControl = this.fb.array([]);
        for (let i = 0; i < value; i++) {
          this.digits.push(this.fb.control(null));
        }
      }
    });
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  override registerOnChange(fn: any): void {
    this.formControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((form) => {
      if (form.indexOf(null) != -1) {
        this.setFocusOnElement(form.indexOf(null));
      }
      const pinCodeVal = form.join('');
      fn(pinCodeVal);
    });
  }

  override ngAfterViewInit() {
    this.setFocusOnElement();
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  override writeValue(value: any): void {
    if (value) {
      this.formControl.patchValue(value);
    } else {
      this.setFocusOnElement();
      this.formControl.reset();
    }
  }

  setFocusOnElement(index = 0) {
    this.inputElements()[index].nativeElement.focus();
  }

  get digits() {
    return this.formControl as FormArray<FormControl>;
  }

  checkIfNumbers(event: KeyboardEvent): void {
    if (isNaN(parseInt(event.key, 10)) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  backspace(index: number, event: any) {
    this.checkIfNumbers(event);

    const inputElements = this.inputElements();
    if (index > 0 && index <= inputElements.length - 1) {
      if (this.digits.controls[index].value) {
        this.digits.controls[index].setValue(null);
        this.setFocusOnElement(index);
      } else {
        this.digits.controls[index - 1].setValue(null);
        this.setFocusOnElement(index - 1);
      }
      event.preventDefault();
    }
  }

  onPaste($event: ClipboardEvent) {
    const characters = $event.clipboardData?.getData('text').split('') ?? [];
    characters.forEach((char, index) => this.digits.controls[index]?.setValue(char));
  }
}
